module.exports = __webpack_public_path__ + "img/close.ebf2f3f4.svg";